import React from "react"
import { Link } from "gatsby"

import styles from "./coursesCategories.module.scss"

import cx from "classnames"

const CourseCategory = ({ cat, slug }) => (
  <div
    key={cat.title}
    className={cx(styles.category, styles.courseCategories, styles[slug])}
    data-theme={cat.color}
  >
    {" "}
    {/* This is a temporary solution. TODO: remove styles[slug] and add genius colour to dropdown select in sanity - studio/schemas/documents/genius.js - and pull it via cat.color */}
    <div
      className={styles.image}
      style={{ backgroundImage: `url(${cat?._rawThumbnail?.asset?.url})` }}
    ></div>
    <div className={styles.textWrapper}>
      <h3 className={styles.title}>{cat.title}</h3>
      <p className={styles.text}>{cat.description}</p>
      <p>
        <Link to={`#${slug || cat.slug.current}`} className={styles.link}>
          Learn more
        </Link>
      </p>
    </div>
  </div>
)

export default CourseCategory
